import { ColumnConfig, CombinedPortfoliosGridExtractorConfig, CombinedPortfoliosGridExtractorConfigOptions, LabelFormatter, LodashExtractor, LodashSeriesEnricherMapper, NumberFormatter, TabConfig } from '@ddt-web/data-service';

import { HOLDINGS_ENRICHER, MODEL_HOLDINGS_COLUMN_CONFIG } from './family-column.config';

export const MODEL_HOLDINGS_CHART = new TabConfig(
	'holdings.chart',
	null,
	CombinedPortfoliosGridExtractorConfig.create({
		mapper: new LodashSeriesEnricherMapper(['familyHoldings'], ['familyHoldings'], 'familyHoldings.components', HOLDINGS_ENRICHER),
		portfolioName: MODEL_HOLDINGS_COLUMN_CONFIG,
		category: ColumnConfig.create({
			id: 'assetClass',
			extractor: new LodashExtractor('formattedAcAssetClass', 'Other'),
			labelFormatter: new LabelFormatter('HOLDINGS_CHART')
		}),
		value: ColumnConfig.create({ id: 'weight', extractor: new LodashExtractor('weight', 0), labelFormatter: new NumberFormatter(NumberFormatter.PERCENT) })
	} as CombinedPortfoliosGridExtractorConfigOptions)
);
